// Typekit
try{Typekit.load({ async: true });}catch(e){}

// Website
$(document).ready(function () {

	'use strict';

	// Lock navigation on home page
	// Shrink navigation on all pages
	const classNameShrink = 'shrink-navigation';
	const navShrinkThreshold = 1;
	$(window).on('scroll', function () {
		if ($(this).scrollTop() > navShrinkThreshold && !$('body').hasClass(classNameShrink))
			$('body').addClass(classNameShrink);
		else if ($(this).scrollTop() < navShrinkThreshold && $('body').hasClass(classNameShrink))
			$('body').removeClass(classNameShrink);
	});

	setTimeout(() => {
		$(window).trigger('scroll');
	}, 2000);

	// Video-Selector
	var videoSelector = $('#video-select');
	videoSelector.on('change', function () {
		window.location.href = videoSelector.val();
	});

	// Video-List
	const videoList = $('#video-list');
	if (videoList.length > 0) {
		const videoListItems = videoList.find('.video-item');
		const descriptionMaxLength = 100;
		videoListItems.each(function () {
			const description = $(this).find('.description');
			const descriptionLength = description.text().length;
			if (descriptionLength > descriptionMaxLength) {
				description.addClass('description--collapse');
				description.on('click', function () {
					$(this).toggleClass('description--collapse');
				});
			}
		});
	}

	// Press-Selector
	var pressSelector = $('#press-select');
	pressSelector.on('change', function () {
		window.location.href = pressSelector.val();
	});

	// Seminarfinder
	var seminarsForm = $('#seminars-form');
	var seminarsList = $('#seminars-list');
	seminarsForm.find('[type="checkbox"]').checkbox();
	//seminarsForm.find('select').selectbox();
	seminarsForm.submit(function (e) {
		e.preventDefault();
		var data = getFormData(this);
		$('body, html').animate({scrollTop: $('#seminars-list').offset().top - 150}, 1000);
		seminarsList.html('');
		seminarsList.addClass('loading');
		$.ajax({
			url: 'index.php?id=2011&type=23012017',
			method: 'POST',
			data: data
		}).done(function (result) {
			setTimeout(function () {
				seminarsList.html(result);
				seminarsList.removeClass('loading');
			}, 2000);
		});
		return false;
	});

	// Date Selectors
	var dateSelectors = $('#seminar-details #seminars-upcoming a');
	var registrationForm = $('#uid-10007');
	var selectedDate = $('#easyform-field-wrap-128 select');
	dateSelectors.on('click', function (e) {
		e.preventDefault();
		var val = $(this).text();
		selectedDate.val(val);
		$('html,body').animate({scrollTop: registrationForm.offset().top}, 750);
	});

	// Adjust Seminar Video Aspect
	var videoFrame = $('#seminar-video');
	if (videoFrame.length) {
		$(window).on('resize', function () {
			var w = videoFrame.width();
			var h = w / (16/9);
			videoFrame.css('height', h);
		});
		$(window).resize();
	}

	// Function getFormData
	function getFormData(form) {
		var paramObj = {};
		$.each($(form).serializeArray(), function(_, kv) {
		  if (paramObj.hasOwnProperty(kv.name)) {
			paramObj[kv.name] = $.makeArray(paramObj[kv.name]);
			paramObj[kv.name].push(kv.value);
		  }
		  else {
			paramObj[kv.name] = kv.value;
		  }
		});
		return paramObj;
	}

	// To Top Link
	$(window).on('scroll', function () {
		if ($(window).scrollTop() >= ($(window).height()*0.7)) {
			$('#totop:not(:visible)').fadeIn();
		}
		else {
			if ($('#totop').is(':visible')) {
				$('#totop').fadeOut();
			}
		}
	});

	// Newsletter Popup
    function showPopup(id) {
        //console.log('Show Popup: '+id);
        var popup = $(id);
        //console.log(popup);
		popup.fadeIn();
    };
	var popups = $('[id*="popup"]');
	var popupCenter = $('[id*="popup"]').find('[id*="form"], [id*="content"]');
	$(window).on('click touchstart', function (e) {
        //console.log('close the popup');
		//console.log($(e.target));
        if (!$(e.target).is('[id*="popup"] *')) {
            popups.fadeOut();
        }
	});
	$(document).on('click touchstart', '[href*="popup"]', function (e) {
		showPopup(this.hash);
		e.preventDefault();
		e.stopPropagation();
	});
	popupCenter.on('click', function (e) {
		e.stopPropagation();
	});
	if (window.location.hash) {
		if (typeof (window.location.hash.toString().split('-')[1] === 'popup')) {
			showPopup(window.location.hash);
		}
	}
    // 2020-02-06 Info Popup
    if (typeof Cookies.get('info-popup-2020') === 'undefined') {
        setTimeout(function () {
            showPopup('#info-popup');
            Cookies.set('info-popup-2020', true, {expires: 1});
        }, 1000);
    }
    
	// Strip empty <p>
	$('p').each(function () {
		var text = $(this).html().trim().replace('&nbsp;', '');
		if (text === '') {
			$(this).remove();
		}
	});

	// Colorize Module Names on KKT
	$('#page-2013 #seminars-list h3').each(function () {
		var text = $(this).text();
		var word = text.split('Techniker ')[1].split(' praxis')[0].split(' (')[0];
		$(this).html(text.replace(word, '<span class="inline">'+word+'</span>'));
	});

	// Mobile Navi
	const nav = document.getElementById('nav');
	const burger = document.getElementById('nav__burger');
	burger.addEventListener('click', () => {
		document.body.classList.toggle('nav-expanded');
	});

	// Seminaranmeldung: Termin Kombitarif
	$('#easyform-field-wrap-127 select').on('change', function () {
		var val = $(this).val();
		var select = $('#easyform-field-wrap-152 select');
		if (val !== '---') {
			$.ajax({
				url: window.location,
				method: 'GET',
				data: {
					type: '1309',
					seminar: val
				}
			})
			.done(function (res) {
                console.log(res);
				select.html(res);
			});
		}
	});
	$('.easyform-field-wrap-127 select').change();

	// Accordions
	$('.accordion-item:not(.disabled)').on('click', function () {
		$(this).toggleClass('active');
	});
	// Forum Anmeldung
	var forumRegister = $($('.forum-register')[0]);
	var forumRegisterDefault = forumRegister.val();
	$('a.register').on('click', function () {
		console.log('Open Forum Registration Popup');
		if ($(this).attr('data-workshop').length) {
			forumRegister.val($(this).attr('data-workshop'));
		}
		else {
			forumRegister.val(forumRegisterDefault);
		}
	});
    
    // Seminaranmeldung: Termin
    $('#seminar-details .seminars-upcoming-date').click(function () {
        var date = $(this).text().trim();
        console.log(date);
        $('#easyform-field-wrap-128 select').val(date); 
    });

	// Anchors
	$(document).on('click', 'a[href*="#"]', function (e) {
		var target = $(this.hash);
		if (target.length === 1) {
			e.preventDefault();
			$('body,html').animate({scrollTop: target.offset().top - nav.offsetHeight - 50});
		}
	});

});